import { lazy, Suspense } from 'react';
import { v2UiEnabled } from '@/components/DmpV2/features';
import { useTranslation } from 'react-i18next';
import useResize from '@/hooks/useResize';
import { WhatsApp } from '@/components/Icon';
import { ChatBox, GoTop } from '@/pages/Index/style';
import LegacyPricing from './LegacyPricing';
const PricingV2 = lazy(() => import('@/components/DmpV2/PricingV2'));
export default function PricingRoute() {
  // @ts-ignore -- i18next key inference exceeds the CRA development checker, as on adjacent Index pages.
  const { t } = useTranslation();
  const { isTablet, isMobile } = useResize();
  return <>
    {v2UiEnabled() ? <Suspense fallback={<p role="status">Loading…</p>}><PricingV2 /></Suspense> : <LegacyPricing />}
    <ChatBox
      isTablet={isTablet}
      isMobile={isMobile}
      href="https://wa.me/85266981322"
      target="_blank"
      rel="noopener noreferrer"
    >
      <p>{t('chatWithUs')}</p>
      <WhatsApp.WhatsAppSVG width={25} height={25} aria-hidden="true" />
    </ChatBox>
    <GoTop
      as="button"
      type="button"
      isTablet={isTablet}
      isMobile={isMobile}
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      {t('top')}
    </GoTop>
  </>;
}
